
export default {
    name: 'IconLogout',
    props: {
        width: {
            type: String,
            default: '23.806px'
        },
        height: {
            type: String,
            default: '23.950px'
        },
        color: {
            type: String,
            default: '#303030'
        }
    }
}
